<template>
  <div class="content">
    <form action="" @submit.prevent="approve_cin">
      <div class="md-layout md-size-100" v-if="negator_data_fetched">
        <md-toolbar :md-elevation="1">
          <span class="md-title md-size-33">Podaci o negatoru</span>
        </md-toolbar>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Ime Negatora</label>
            <md-input
              v-model="working_entry.negator.negator_ime_naziv"
              :disabled="akter_locked"
              required
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Opis Negatora</label>
            <md-input
              v-model="working_entry.negator.negator_opis"
              :disabled="akter_locked"
              required
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="rod">Rod Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_rod"
              name="negator_rod"
              id="negator_rod"
              placeholder="Rod"
              :disabled="akter_locked"
            >
              <md-option value="M">M</md-option>
              <md-option value="Ž">Ž</md-option>
              <md-option value="NA">Nepoznato</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="negator_financiranje">Izvor Financiranja</label>
            <md-select
              v-model="working_entry.negator.negator_financiranje"
              name="negator_financiranje"
              id="negator_financiranje"
              :disabled="akter_locked"
              
            >
              <md-option value=""></md-option>
              <md-option value="Poznato: Javna sredstva"
                >Poznato: Javna sredstva</md-option
              >
              <md-option value="Poznato: Donacije">Poznato: Donacije</md-option>
              <md-option value="Poznato: Komercijalno"
                >Poznato: Komercijalno</md-option
              >
              <md-option value="NA">Nepoznato</md-option>
              <md-option value="Nepoznato">Nepoznato</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="negator_drzava">Država Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_drzava"
              name="negator_drzava"
              id="negator_drzava"
              placeholder="negator_drzava"
              :disabled="akter_locked"
              
            >
              <md-option value=""></md-option>
              <md-option value="Bosna i Hercegovina"
                >Bosna i Hercegovina</md-option
              >
              <md-option value="Bosna i Hercegovina - RS"
                >Bosna i Hercegovina - RS</md-option
              >
              <md-option value="Bosna i Hercegovina - FBiH"
                >Bosna i Hercegovina - FBiH</md-option
              >
              <md-option value="Bosna i Hercegovina - BD"
                >Bosna i Hercegovina - BD</md-option
              >
              <md-option value="Republika Srbija">Republika Srbija</md-option>
              <md-option value="Crna Gora ili Hrvatska"
                >Crna Gora ili Hrvatska</md-option
              >
              <md-option value="Ostale države iz regije"
                >Ostale države iz regije</md-option
              >
              <md-option value="Ostale države">Ostale države</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="negator_sektor">Sektor Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_sektor"
              name="negator_sektor"
              id="negator_sektor"
              placeholder="negator_sektor"
              :disabled="akter_locked"
              
            >
              <md-option value=""></md-option>
              <md-option value="Javni (državni)">Javni (državni)</md-option>
              <md-option value="Komercijalni (privatni)"
                >Komercijalni (privatni)</md-option
              >
              <md-option value="Neprofitni">Neprofitni</md-option>
              <md-option value="NA">Nepoznato</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="negator_karakteristike">Karakteristike Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_karakteristike"
              name="negator_karakteristike"
              id="negator_karakteristike"
              placeholder="negator_karakteristike"
              :disabled="akter_locked"
            >
              <md-option value=""></md-option>
              <md-option value="Zvaničnik/ca izvršne vlasti"
                >Zvaničnik/ca izvršne vlasti</md-option
              >
              <md-option value="Zvaničnik/ca zakonodavne vlasti"
                >Zvaničnik/ca zakonodavne vlasti</md-option
              >
              <md-option value="Zvaničnik/ca pravosuđe"
                >Zvaničnik/ca pravosuđe</md-option
              >
              <md-option value="Javni/a službenik/ca"
                >Javni/a službenik/ca</md-option
              >
              <md-option value="Privatno lice">Privatno lice</md-option>
              <md-option value="Javna ličnost">Javna ličnost</md-option>
              <md-option value="Institucija">Institucija</md-option>
              <md-option value="Organizacija">Organizacija</md-option>
              <md-option value="Neformalna grupa">Neformalna grupa</md-option>
              <md-option value="Medij">Medij</md-option>
              <md-option value="Religijska ustanova"
                >Religijska ustanova</md-option
              >
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Uloga u Ratu Negatora</label>
            <md-input
              :disabled="akter_locked"
              v-model="working_entry.negator.negator_uloga_u_ratu"
            ></md-input>
          </md-field>
        </div>
      </div>


    <div class="md-layout">
    <md-button
    type="submit"
        class="md-dense md-raised md-primary submit"
        >Spasi izmjenu</md-button
    >
    </div>
    </form>
    <md-dialog :md-active.sync="show_modal_success">
      <md-dialog-title>Uspješan unos</md-dialog-title>

        <div class="md-layout">
          <p class="md-layout-item">Unos je uspješno spašen, hvala vam na vašem doprinosu!</p>
        </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="reload_page">Zatvoriti</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="show_modal_error">
      <md-dialog-title>Greška pri unosu!</md-dialog-title>

        <div class="md-layout">
          <p class="md-layout-item">{{aktivni_error_text}}</p>
        </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="show_modal_error = false">Zatvoriti</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
  
</template>

<script>
import axios from "axios";
export default {
  name: "Ispravka",
  methods: {
    reload_page(event){
      this.$router.push('/negatori')
    },
    async approve_cin(event) {
      const token = await this.$auth.getTokenSilently()
      if(this.working_entry.negator.negator_ime_naziv == "" | this.working_entry.negator.negator_opis == "")
      {
        return null
      }

      var data_prepared = {
        cin: {},
        negator: {},
        platforma: {},
      };
      if (this.working_entry.cin.cin_uuid_negator == "") {
        data_prepared.negator = this.working_entry.negator;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      };

      axios
        .put(
          "https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori/"+this.$route.params.id,
          data_prepared.negator,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            this.show_modal_success = true
          } 
        })
        .catch((error) => {
          
           
        this.aktivni_error_text = this.opci_error_text;   
        this.show_modal_error = true;          
        });
    }
        
  },
  data: () => ({
    initial: "Initial Value",
    type: null,
    naming_conflict: "Negator ili platforma kojeu pokušavate unijeti već postoji u bazi podataka, molim vas odaberite već postojeće iz dropdowna.",
    opci_error_text:"Došlo je do neočekivane greške tokom unosa podataka, molim vas napravite screenshot i pošaljite nam ga da možemo provjeriti u čemu je problem. Izvinjavamo se zbog smetnje",
    aktivni_error_text: "",
    show_modal_error: false,
    show_modal_success: false,
    data_fetched: false,
    withLabel: null,
    inline: null,
    number: null,
    textarea: null,
    autogrow: null,
    disabled: null,
    working_negator: {},
    active_entry: {},
    working_entry: {
      cin: {
        cin_nacin_negiranja: "",
        cin_datum: "",
        cin_uuid_platforma: "",
        cin_uuid_negator: "",
        cin_drzava: "",
        cin_naslov: "",
        cin_link: "",
        cin_citat_opis: "",
      },
      negator: {
        negator_financiranje: "",
        negator_drzava: "",
        negator_ime_naziv: "",
        negator_oblast: "",
        negator_rod: "",
        negator_sektor: "",
        negator_karakteristike: "",
        negator_uloga_u_ratu: "",
        negator_opis: "",
      },
      platforma: {
        platforma_lokacija: "",
        platforma_opis: "",
        platforma_tip_medija: "",
        platforma_financiranje_sektor: "",
        platforma_naziv: "",
      },
    },
    akter_locked: false,
    negator_data_fetched: false
  }),
  mounted: async function () {
    const token = await this.$auth.getTokenSilently()
    axios
      .get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori/"+this.$route.params.id,
      {headers:{Authorization: `Bearer ${token}`}})
      .then(((response) => {
          this.working_entry.negator = response.data
        }))
        .then((response) => {this.negator_data_fetched = true;})    
  }
};
</script>